import Textfield, { TextFieldProps } from '@atlaskit/textfield';
import { css } from '@emotion/react';
import StyledLabelLarge from './StyledLabelLarge';

const bigFontStyles = css({
  paddingRight: 10,
  color: 'black',
  '& > [data-ds--text-field--input]': {
    fontSize: 14,
    color: 'black',
  },
});
type Props = {
  name: string;
  placeholder: string;
  value?: string;
  // eslint-disable-next-line no-unused-vars
  onChangeValue?: (value: string) => void;
} & Partial<TextFieldProps>;

export default function StyledUserProfileElementsLarge({
  name,
  placeholder,
  value,
  onChangeValue,
  ...props
}: Props) {
  return (
    <div className="part">
      <div className="row" style={{ display: 'flex', flexDirection: 'row' }}>
        <div className="Name" style={{ padding: 20 }}>
          <StyledLabelLarge label={name} />
        </div>
        <div style={{ width: 150, borderRadius: 3, marginTop: 20 }}>
          <Textfield
            aria-label="customized text field"
            placeholder={placeholder}
            value={value}
            css={bigFontStyles}
            style={{ borderRadius: 3 }}
            color="black"
            isCompact
            {...props}
          />
        </div>
      </div>
    </div>
  );
}
